export interface RecordSection<T> {
  records: T[];
  total: number;
  inactive_total: number | null;
  has_more: boolean;
}

export interface ActiveFlagged {
  active: boolean | null;
}

export const activeFirst = <T extends ActiveFlagged>(records: T[]): T[] =>
  [...records].sort((a, b) => Number(b.active === true) - Number(a.active === true));

export const countedTitle = (title: string, count: number | null | undefined): string =>
  count === null || count === undefined ? title : `${title} (${count})`;

const MORE_RECORDS_TAIL = 'records: every active one and the most recent inactive ones.';
const MORE_RECENT_RECORDS_TAIL = 'records: the most recent ones.';

export const moreRecordsNote = (section: RecordSection<unknown>): string | undefined => {
  if (!section.has_more) return undefined;
  const tail = section.inactive_total === null ? MORE_RECENT_RECORDS_TAIL : MORE_RECORDS_TAIL;
  return `Showing ${section.records.length} of ${section.total} ${tail}`;
};
